const API_CONSTANTS = {
    base_url: "https://api.azizbek.co.uk",
    //base_url: "http://localhost:8080", // - for local development
    auth_token: "p13otepgofdjgk3981903lfdjglkj3908109oiwejfisaj2-0840-938929lkdkjlasdioqwdsalk",

    is_debug: false
}

export default API_CONSTANTS;
